export default __webpack_public_path__ + "product-16-nTm.png";